import { useDispatch, useSelector } from "react-redux";

import { AIAgentPromptGroup, type AIAgentPromptGroupProps } from "../../components/AIAgentPromptGroup";
import AIAgentTrackingService from "../../services/tracking/trackingService";
import { clearChatText, selectChatText, setChatText } from "../../store";

type Props = Pick<AIAgentPromptGroupProps, "isFocusTriggered" | "isInputLocked" | "placeholder"> & {
    onSubmit: (text: string) => void;
};

const AIAgentPromptGroupContainer = ({ isFocusTriggered, isInputLocked, placeholder, onSubmit }: Props) => {
    const dispatch = useDispatch();

    const text = useSelector(selectChatText);

    const handleTextChange = (value: string | undefined) => {
        dispatch(setChatText(value ?? ""));
    };

    const handleClearText = (): void => {
        dispatch(clearChatText());
    };

    const handleSubmit = (): void => {
        AIAgentTrackingService.leadGenerator.trackHumanMessageSubmit(text);

        onSubmit(text);
        handleClearText();
    };

    return (
        <AIAgentPromptGroup
            value={text}
            isFocusTriggered={isFocusTriggered}
            isInputLocked={isInputLocked}
            isSubmitLocked={isInputLocked}
            placeholder={placeholder}
            onChange={handleTextChange}
            onSubmit={handleSubmit}
        />
    );
};

export default AIAgentPromptGroupContainer;
